function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.79 20.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.03.59h-4.19c-.67,0-1.21.54-1.21,1.21v4.19c0,.67.54,1.21,1.21,1.21h4.19c.67,0,1.21-.54,1.21-1.21V1.8c0-.67-.54-1.21-1.21-1.21Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: "1.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.99,13.27H1.8c-.67,0-1.21.54-1.21,1.21v4.19c0,.67.54,1.21,1.21,1.21h4.19c.67,0,1.21-.54,1.21-1.21v-4.19c0-.67-.54-1.21-1.21-1.21Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: "1.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.99,13.27h-4.19c-.67,0-1.21.54-1.21,1.21v4.19c0,.67.54,1.21,1.21,1.21h4.19c.67,0,1.21-.54,1.21-1.21v-4.19c0-.67-.54-1.21-1.21-1.21Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: "1.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.03,13.27h-4.19c-.67,0-1.21.54-1.21,1.21v4.19c0,.67.54,1.21,1.21,1.21h4.19c.67,0,1.21-.54,1.21-1.21v-4.19c0-.67-.54-1.21-1.21-1.21Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: "1.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.94,13.16v-6.28",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.93,13.27v-3.91h18v3.91",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".88px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/DB.02af52806d1fc7dd77c64d7f681de854.svg";
export { ForwardRef as ReactComponent };